<template>
    <div v-if="loading" class="loader-container">
        <p>Loading...</p>
    </div>
    <div v-else class="iframe-container relative">
        <iframe type="text/javascript" width="100%" height="100%" scrolling="no" :src="finalUrl"
            frameborder="0"></iframe>
        <div v-if="shouldMask" class="w-[60px] h-[300px] absolute top-0 right-0 z-[2000]"></div>
    </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
    setup() {
        const loading = ref(true);
        const urlMapping = ref({});
        const finalUrl = ref('');
        const route = useRoute();
        const spreadsheetId = '1cr7-4SknFi3vuKuDG9nuxKG4P_4zJU9Xi94_Q3aAKag';
        const sheetName = 'Sheet1';
        const defaultUrl = 'https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FO9AXW8FG5K&locale=en_US';

        const parseCsv = (text) => {
            const rows = [];
            let row = [];
            let value = '';
            let inQuotes = false;

            for (let index = 0; index < text.length; index += 1) {
                const character = text[index];
                const nextCharacter = text[index + 1];

                if (character === '"' && inQuotes && nextCharacter === '"') {
                    value += '"';
                    index += 1;
                } else if (character === '"') {
                    inQuotes = !inQuotes;
                } else if (character === ',' && !inQuotes) {
                    row.push(value);
                    value = '';
                } else if ((character === '\n' || character === '\r') && !inQuotes) {
                    if (character === '\r' && nextCharacter === '\n') {
                        index += 1;
                    }
                    row.push(value);
                    rows.push(row);
                    row = [];
                    value = '';
                } else {
                    value += character;
                }
            }

            if (value || row.length) {
                row.push(value);
                rows.push(row);
            }

            return rows;
        };

        const fetchGoogleSheetData = async () => {
            const sheetUrl = `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:csv&sheet=${encodeURIComponent(sheetName)}`;

            try {
                const response = await fetch(sheetUrl);

                if (!response.ok) {
                    throw new Error('Unable to load 3D model links');
                }

                const rows = parseCsv(await response.text());
                const mapping = {};

                rows.forEach(row => {
                    if (row[0] && row[1]) {
                        mapping[`/3dmodels/${row[0]}`] = row[1];
                    }
                });

                urlMapping.value = mapping;
            } catch {
                urlMapping.value = {};
            } finally {
                updateFinalUrl();
                loading.value = false;
            }
        };

        const updateFinalUrl = () => {
            finalUrl.value = urlMapping.value[route.fullPath] || defaultUrl;
        };

        const shouldMask = computed(() => {
            return !route.fullPath.endsWith('$');
        });

        onMounted(() => {
            fetchGoogleSheetData();
        });

        watch(() => route.fullPath, updateFinalUrl);

        return { loading, finalUrl, shouldMask };
    }
};
</script>

<style scoped>
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
}

.iframe-container {
    width: 100vw;
    height: 100vh;
}

iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
